import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router"
import { debounce } from "es-toolkit/function"
import { graphql } from "relay-runtime"
import { SearchInput } from "@/components/ui/search"
import { PatientNameNavigationState } from "@/modules/patients/components/patient-table-action-menu"
import { useWaitingRoomSearchContext } from "@/modules/waiting-room/contexts/waiting-room-filters-context"

export const WaitingRoomAppointmentSearchAppointmentFragment = graphql`
  fragment appointmentSearch_WaitingRoomAppointment on WaitingRoomAppointment {
    appointment {
      id
      appointmentId
      reason
      patient {
        id
        patientId
        displayId
        firstName
        lastName
        birthDate
      }
    }
  }
`

export const AppointmentSearch = () => {
  const { t } = useTranslation()
  const setSearchValue = useWaitingRoomSearchContext((state) => state.setSearchValue)
  const searchValue = useWaitingRoomSearchContext((state) => state.searchValue)
  const [keyword, setKeyword] = useState(searchValue)
  const location = useLocation()

  const debouncedSetSearchValue = useMemo(
    () => debounce((value: string) => setSearchValue(value), 300),
    [setSearchValue],
  )

  useEffect(() => {
    const locationState: PatientNameNavigationState = location.state
    const searchValueFromLocation = locationState?.patientName

    if (searchValueFromLocation) {
      setKeyword(searchValueFromLocation)
      debouncedSetSearchValue(searchValueFromLocation)
    }
  }, [debouncedSetSearchValue, location])
  return (
    <SearchInput
      className="bg-surface"
      wrapperClassName="flex self-start"
      data-testid="waiting-room-search-input"
      value={keyword}
      placeholder={t("common.search")}
      autoComplete="off"
      onChange={({ target: { value } }) => {
        setKeyword(value)
        if (value.length >= 3) {
          debouncedSetSearchValue(value)
        } else {
          debouncedSetSearchValue("")
        }
      }}
      onClear={() => {
        setSearchValue("")
        setKeyword("")
      }}
    />
  )
}
